// Auto-structured from the official Jejak Semangat privacy notice (Bahasa Melayu).
// Inline **text** marks bold; e-mail addresses and URLs are linked by the renderer.
const privacyNoticeMs = {
  "lang": "ms",
  "label": "Bahasa Melayu",
  "title": "Notis Privasi Jejak Semangat Sdn Bhd",
  "intro": [
    {
      "type": "p",
      "text": "Jejak Semangat Sdn Bhd (\"Jejak Semangat\", \"kami\" atau \"kita\") menghormati privasi anda dan komited untuk melindungi Data Peribadi anda selaras dengan Akta Perlindungan Data Peribadi 2010 (Akta 709) (\"PDPA\"), termasuk Akta Perlindungan Data Peribadi (Pindaan) 2024, serta undang-undang dan peraturan lain yang terpakai di Malaysia."
    },
    {
      "type": "p",
      "text": "Notis Privasi ini menerangkan cara Jejak Semangat mengumpul, merekod, menyimpan, menggunakan, memproses, mendedahkan dan melindungi Data Peribadi anda apabila anda mengakses atau menggunakan aplikasi mudah alih kami, membeli atau melanggan produk dan perkhidmatan telekomunikasi kami, mendaftar untuk kad SIM, berurusan dengan wakil kami atau berinteraksi dengan kami dalam apa jua cara."
    },
    {
      "type": "p",
      "text": "Kami komited untuk mengendalikan Data Peribadi anda secara bertanggungjawab, telus dan selamat. Kami memproses Data Peribadi hanya bagi tujuan yang sah dan berkaitan dengan operasi perniagaan serta penyediaan produk dan perkhidmatan kami, tertakluk kepada keperluan undang-undang yang terpakai."
    },
    {
      "type": "p",
      "text": "Dengan memberikan Data Peribadi anda kepada kami atau menggunakan produk dan perkhidmatan kami, anda mengakui bahawa anda telah dimaklumkan tentang perkara yang dinyatakan dalam Notis Privasi ini. Jika persetujuan diperlukan di bawah undang-undang yang terpakai, kami akan mendapatkan persetujuan anda melalui kaedah yang sewajarnya sebelum menjalankan aktiviti pemprosesan yang berkaitan."
    }
  ],
  "sections": [
    {
      "title": "Skop Notis Privasi",
      "blocks": [
        {
          "type": "p",
          "text": "Notis Privasi ini terpakai kepada semua individu yang Data Peribadinya dikumpul atau diproses oleh Jejak Semangat berkaitan dengan aktiviti perniagaan kami, termasuk:"
        },
        {
          "type": "ul",
          "items": [
            "Pelanggan atau pelanggan berdaftar sedia ada dan bakal pelanggan",
            "Individu yang mendaftar untuk atau membeli kad SIM dan pakej telekomunikasi Jejak Semangat",
            "Pekerja asing dan individu lain yang menggunakan perkhidmatan telekomunikasi mudah alih kami",
            "Individu yang mengakses atau menggunakan aplikasi mudah alih, laman web atau platform digital kami yang lain",
            "Individu yang berhubung dengan wakil khidmat pelanggan atau ejen jualan kami yang diberi kuasa",
            "Individu lain yang Data Peribadinya diberikan kepada kami berkaitan dengan produk, perkhidmatan atau operasi perniagaan kami"
          ]
        },
        {
          "type": "p",
          "text": "Notis Privasi ini terpakai kepada Data Peribadi yang dikumpul melalui aplikasi mudah alih, laman web, saluran pendaftaran, wakil jualan, saluran khidmat pelanggan, rakan niaga dan sumber lain yang berkaitan."
        },
        {
          "type": "p",
          "text": "Notis Privasi ini hendaklah dibaca bersama-sama dengan sebarang notis atau terma tambahan yang mungkin diberikan kepada anda berhubung dengan produk, perkhidmatan atau aktiviti tertentu."
        }
      ],
      "id": "section-1"
    },
    {
      "title": "Data Peribadi yang Dikumpul",
      "blocks": [
        {
          "type": "p",
          "text": "Bergantung pada jenis interaksi anda dengan kami serta produk atau perkhidmatan yang anda gunakan, Jejak Semangat mungkin mengumpul dan memproses kategori Data Peribadi berikut:"
        },
        {
          "type": "h",
          "text": "A. Maklumat Pengenalan Diri"
        },
        {
          "type": "ul",
          "items": [
            "Nama penuh;",
            "Nombor pasport dan butiran pasport;",
            "Kewarganegaraan;",
            "Tarikh lahir;",
            "Jantina;",
            "Gambar pasport atau salinan dokumen pengenalan diri, jika diperlukan;",
            "Maklumat lain yang diperlukan untuk pengenalan diri dan pengesahan pelanggan berdaftar."
          ]
        },
        {
          "type": "h",
          "text": "B. Maklumat Perhubungan dan Kediaman"
        },
        {
          "type": "ul",
          "items": [
            "Nombor telefon mudah alih;",
            "Alamat kediaman atau alamat surat-menyurat;",
            "Alamat e-mel;",
            "Maklumat untuk dihubungi ketika kecemasan, jika berkenaan."
          ]
        },
        {
          "type": "h",
          "text": "C. Maklumat Pekerjaan dan Imigresen"
        },
        {
          "type": "ul",
          "items": [
            "Nama majikan atau syarikat, jika berkenaan;",
            "Butiran berkaitan pekerjaan;",
            "Butiran permit kerja;",
            "Dokumen dan maklumat imigresen yang berkaitan serta diperlukan untuk pendaftaran atau pengesahan pelanggan berdaftar."
          ]
        },
        {
          "type": "h",
          "text": "D. Maklumat Pelanggan Berdaftar dan Telekomunikasi"
        },
        {
          "type": "ul",
          "items": [
            "Nombor siri kad SIM;",
            "Nombor Rangkaian Digital Perkhidmatan Bersepadu Pelanggan Mudah Alih (MSISDN);",
            "Maklumat dan status pendaftaran pelanggan berdaftar;",
            "Rekod pengaktifan dan penyahaktifan kad SIM;",
            "Maklumat pakej mudah alih dan langganan;",
            "Rekod pembelian, pembaharuan dan pengaktifan pakej;",
            "Maklumat penggunaan perkhidmatan telekomunikasi dan rekod teknikal berkaitan, setakat maklumat tersebut diberikan kepada atau diproses oleh kami."
          ]
        },
        {
          "type": "h",
          "text": "E. Maklumat Pembayaran dan Transaksi"
        },
        {
          "type": "ul",
          "items": [
            "Sejarah pembelian pakej;",
            "Butiran transaksi pembayaran;",
            "Nombor rujukan transaksi;",
            "Amaun pembayaran dan status pembayaran;",
            "Rekod bayaran balik, pelarasan dan perkara berkaitan pembayaran."
          ]
        },
        {
          "type": "h",
          "text": "F. Maklumat Teknikal dan Digital"
        },
        {
          "type": "ul",
          "items": [
            "Alamat Protokol Internet (IP);",
            "Jenis peranti dan pengecam peranti;",
            "Maklumat penggunaan aplikasi mudah alih;",
            "Log akses aplikasi dan log teknikal;",
            "Kuki (cookies) dan teknologi seumpamanya, jika berkenaan;",
            "Maklumat teknikal lain yang dijana melalui penggunaan platform digital kami."
          ]
        },
        {
          "type": "h",
          "text": "G. Maklumat Komunikasi dan Khidmat Pelanggan"
        },
        {
          "type": "ul",
          "items": [
            "Pertanyaan dan aduan pelanggan;",
            "Rekod surat-menyurat dan komunikasi;",
            "Maklum balas pelanggan;",
            "Rekod interaksi dengan wakil dan kakitangan khidmat pelanggan kami."
          ]
        },
        {
          "type": "p",
          "text": "Kami juga mungkin mengumpul maklumat lain sekiranya maklumat tersebut diperlukan untuk penyediaan produk dan perkhidmatan kami atau dikehendaki oleh undang-undang dan peraturan yang terpakai."
        },
        {
          "type": "p",
          "text": "Sekiranya kami mengumpul Data Peribadi Sensitif, kami hanya akan memproses maklumat tersebut setakat yang dibenarkan di bawah undang-undang yang terpakai dan tertakluk kepada keperluan undang-undang berkaitan."
        }
      ],
      "id": "section-2"
    },
    {
      "title": "Sumber Data Peribadi",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat mungkin memperoleh Data Peribadi anda daripada pelbagai sumber, termasuk:"
        },
        {
          "type": "ol",
          "items": [
            "**Secara langsung daripada anda: Apabila anda mendaftar untuk kad SIM, melanggan pakej telekomunikasi, mengemukakan maklumat melalui aplikasi mudah alih kami, membuat pembayaran, menghubungi wakil khidmat pelanggan kami atau memberikan maklumat kepada kami melalui cara lain.**",
            "**Melalui wakil atau saluran jualan kami yang diberi kuasa: Apabila anda mendaftar atau membeli produk dan perkhidmatan kami melalui wakil jualan, ejen atau saluran lain yang diberi kuasa.**",
            "**Daripada Pembekal Perkhidmatan Telekomunikasi: Apabila pembekal perkhidmatan yang berkaitan memberikan maklum balas pendaftaran, keputusan pengesahan pelanggan berdaftar, status kelulusan MSISDN, keputusan pengaktifan pakej, maklumat perkhidmatan atau maklumat lain yang berkaitan dengan perkhidmatan telekomunikasi yang diberikan kepada anda.**",
            "**Daripada penyedia perkhidmatan pembayaran dan institusi kewangan: Jika diperlukan untuk memproses, mengesahkan dan menyelaraskan pembayaran atau transaksi yang dibuat berkaitan dengan produk dan perkhidmatan kami.**",
            "**Daripada penyedia perkhidmatan pihak ketiga dan rakan niaga: Apabila maklumat tersebut diberikan berkaitan dengan perkhidmatan atau aktiviti yang melibatkan Jejak Semangat.**",
            "**Daripada sumber yang tersedia kepada umum atau pihak berkuasa berkaitan: Setakat yang dibenarkan oleh undang-undang yang terpakai dan diperlukan bagi tujuan pengesahan, pematuhan atau tujuan perniagaan lain yang sah.**"
          ]
        }
      ],
      "id": "section-3"
    },
    {
      "title": "Tujuan Pengumpulan dan Pemprosesan Data Peribadi",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat mengumpul dan memproses Data Peribadi anda bagi tujuan berikut:"
        },
        {
          "type": "h",
          "text": "A. Pendaftaran dan Pengesahan Pelanggan"
        },
        {
          "type": "ul",
          "items": [
            "Untuk mendaftarkan pelanggan dan memudahkan langganan kad SIM;",
            "Untuk mengesahkan identiti pelanggan dan mengesahkan kesahihan maklumat pendaftaran;",
            "Untuk mengumpul dan mengemukakan maklumat pelanggan berdaftar yang berkaitan kepada pembekal perkhidmatan berkaitan bagi tujuan pemprosesan dan kelulusan pendaftaran;",
            "Untuk menerima maklum balas kelulusan atau penolakan pendaftaran pelanggan daripada pembekal perkhidmatan berkaitan;",
            "Untuk menyelenggara dan mengemas kini rekod pelanggan berdaftar dan MSISDN yang telah diluluskan dalam sistem kami;",
            "Untuk memudahkan pengeluaran dan pengaktifan kad SIM serta pentadbiran akaun pelanggan berdaftar."
          ]
        },
        {
          "type": "h",
          "text": "B. Perkhidmatan Telekomunikasi dan Pengurusan Pakej"
        },
        {
          "type": "ul",
          "items": [
            "Untuk menyediakan perkhidmatan telekomunikasi mudah alih dan pakej SIM;",
            "Untuk memudahkan pembelian, langganan, pembaharuan dan pengaktifan pakej mudah alih;",
            "Untuk menghantar permintaan pengaktifan pakej dan maklumat pelanggan berdaftar yang berkaitan kepada pembekal perkhidmatan berkaitan melalui sistem bersepadu dan antara muka pengaturcaraan aplikasi (API).",
            "Untuk mengurus langganan pelanggan, status pakej dan pertanyaan berkaitan perkhidmatan;",
            "Untuk menyampaikan maklumat berhubung ketersediaan perkhidmatan, perubahan pakej dan kemas kini perkhidmatan."
          ]
        },
        {
          "type": "h",
          "text": "C. Pengurusan Pembayaran dan Transaksi"
        },
        {
          "type": "ul",
          "items": [
            "Untuk memproses pembayaran bagi kad SIM, pakej telekomunikasi dan perkhidmatan berkaitan;",
            "Untuk menyelenggara rekod transaksi dan pembayaran;",
            "Untuk mengesahkan status pembayaran dan menyelaraskan transaksi;",
            "Untuk mengurus bayaran balik, pelarasan dan pertanyaan berkaitan pembayaran."
          ]
        },
        {
          "type": "h",
          "text": "D. Khidmat Pelanggan dan Komunikasi"
        },
        {
          "type": "ul",
          "items": [
            "Untuk menjawab pertanyaan, aduan dan permintaan pelanggan;",
            "Untuk menyediakan bantuan teknikal dan sokongan pelanggan;",
            "Untuk memaklumkan hasil pendaftaran, pengesahan pembayaran dan maklumat langganan;",
            "Untuk memaklumkan pelanggan tentang pengumuman perkhidmatan, perubahan dan kemas kini yang berkaitan."
          ]
        },
        {
          "type": "h",
          "text": "E. Operasi dan Pentadbiran Perniagaan"
        },
        {
          "type": "ul",
          "items": [
            "Untuk menyelenggara pangkalan data pelanggan dan rekod perniagaan;",
            "Untuk menjalankan pentadbiran dalaman, pelaporan dan pengauditan;",
            "Untuk memantau dan menambah baik produk, perkhidmatan dan platform digital kami;",
            "Untuk menganalisis prestasi perkhidmatan dan maklum balas pelanggan;",
            "Untuk mengekalkan keselamatan dan integriti sistem perniagaan kami."
          ]
        },
        {
          "type": "h",
          "text": "F. Keselamatan, Pencegahan Penipuan dan Pematuhan Undang-undang"
        },
        {
          "type": "ul",
          "items": [
            "Untuk mengesan, menyiasat dan mencegah aktiviti penipuan, tanpa kebenaran atau mencurigakan;",
            "Untuk melindungi pelanggan, operasi perniagaan dan sistem kami;",
            "Untuk mematuhi undang-undang, peraturan, keperluan kawal selia yang terpakai serta permintaan yang sah daripada pihak berkuasa berkaitan;",
            "Untuk menegakkan, melaksanakan atau mempertahankan hak dan tuntutan undang-undang."
          ]
        },
        {
          "type": "h",
          "text": "G. Pemasaran dan Promosi"
        },
        {
          "type": "ul",
          "items": [
            "Untuk memberikan maklumat mengenai produk, perkhidmatan, promosi dan tawaran istimewa kami;",
            "Untuk menjalankan aktiviti penglibatan pelanggan dan pemasaran, setakat yang dibenarkan oleh undang-undang yang terpakai;",
            "Untuk meningkatkan kesesuaian produk dan komunikasi promosi kami berdasarkan pilihan pelanggan, jika berkenaan."
          ]
        },
        {
          "type": "p",
          "text": "Kami tidak akan menggunakan Data Peribadi anda bagi tujuan yang berbeza secara material daripada tujuan yang dinyatakan di atas tanpa memberikan notis yang sewajarnya dan mendapatkan persetujuan jika dikehendaki oleh undang-undang yang terpakai."
        }
      ],
      "id": "section-4"
    },
    {
      "title": "Pendedahan Data Peribadi kepada Pihak Ketiga",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat mungkin mendedahkan Data Peribadi anda kepada pihak ketiga yang berkaitan apabila diperlukan bagi tujuan yang diterangkan dalam Notis Privasi ini, tertakluk kepada undang-undang dan peraturan yang terpakai."
        },
        {
          "type": "p",
          "text": "Pihak ketiga tersebut mungkin termasuk:"
        },
        {
          "type": "h",
          "text": "A. Pembekal Perkhidmatan Telekomunikasi"
        },
        {
          "type": "p",
          "text": "Sebagai sebahagian daripada operasi perniagaan kami, kami mungkin mendedahkan Data Peribadi yang berkaitan kepada pembekal perkhidmatan telekomunikasi dan wakil mereka yang diberi kuasa bagi tujuan termasuk pendaftaran pelanggan berdaftar, pengesahan identiti, kelulusan pendaftaran, pengaktifan kad SIM, pengaktifan pakej mudah alih, penyediaan perkhidmatan telekomunikasi, operasi rangkaian serta keperluan kawal selia atau operasi yang berkaitan."
        },
        {
          "type": "h",
          "text": "B. Penyedia Perkhidmatan Pembayaran dan Institusi Kewangan"
        },
        {
          "type": "p",
          "text": "Maklumat pembayaran yang berkaitan mungkin didedahkan kepada bank, gerbang pembayaran, penyedia perkhidmatan pembayaran dan institusi kewangan bagi tujuan pemprosesan pembayaran, pengesahan, penyelesaian, penyelarasan dan bayaran balik."
        },
        {
          "type": "h",
          "text": "C. Penyedia Teknologi dan Perkhidmatan"
        },
        {
          "type": "p",
          "text": "Kami mungkin mendedahkan Data Peribadi yang berkaitan kepada penyedia perkhidmatan pihak ketiga yang menyokong operasi perniagaan kami, termasuk pembangun aplikasi mudah alih, penyedia pengehosan awan, penyedia infrastruktur IT, penyedia penyelenggaraan sistem, penyedia penyimpanan data dan penyedia sokongan teknikal."
        },
        {
          "type": "h",
          "text": "D. Rakan Niaga dan Wakil yang Diberi Kuasa"
        },
        {
          "type": "p",
          "text": "Kami mungkin mendedahkan maklumat yang berkaitan kepada ejen, wakil, pengedar dan rakan niaga kami yang diberi kuasa apabila diperlukan untuk memudahkan pendaftaran pelanggan, jualan produk, khidmat pelanggan dan aktiviti perniagaan yang berkaitan."
        },
        {
          "type": "h",
          "text": "E. Penasihat Profesional dan Juruaudit"
        },
        {
          "type": "p",
          "text": "Jika perlu, kami mungkin mendedahkan Data Peribadi yang berkaitan kepada peguam, akauntan, juruaudit, perunding dan penasihat profesional lain bagi tujuan perniagaan, undang-undang, pematuhan atau pengauditan yang sah."
        },
        {
          "type": "h",
          "text": "F. Pihak Berkuasa Kawal Selia dan Agensi Kerajaan"
        },
        {
          "type": "p",
          "text": "Kami mungkin mendedahkan Data Peribadi kepada pihak berkuasa kawal selia, agensi kerajaan, agensi penguatkuasaan undang-undang atau pihak lain yang diberi kuasa apabila dikehendaki atau dibenarkan di bawah undang-undang, peraturan, perintah mahkamah atau permintaan yang sah."
        },
        {
          "type": "h",
          "text": "G. Pihak Lain yang Berkaitan"
        },
        {
          "type": "p",
          "text": "Kami mungkin mendedahkan Data Peribadi kepada pihak lain apabila diperlukan bagi tujuan pengumpulan maklumat tersebut, dengan persetujuan anda jika diperlukan, atau sebagaimana yang dibenarkan oleh undang-undang yang terpakai."
        },
        {
          "type": "p",
          "text": "Kami mengambil langkah yang munasabah untuk memastikan pihak ketiga yang menerima Data Peribadi daripada kami tertakluk kepada kewajipan kerahsiaan, keselamatan dan perlindungan data yang sewajarnya, dengan mengambil kira sifat maklumat dan perkhidmatan yang diberikan."
        }
      ],
      "id": "section-5"
    },
    {
      "title": "Persetujuan dan Pilihan Anda",
      "blocks": [
        {
          "type": "p",
          "text": "Dengan memberikan Data Peribadi anda kepada Jejak Semangat, anda mengakui bahawa anda telah dimaklumkan tentang tujuan Data Peribadi anda mungkin dikumpul, diproses dan didedahkan seperti yang diterangkan dalam Notis Privasi ini."
        },
        {
          "type": "p",
          "text": "Jika dikehendaki oleh undang-undang yang terpakai, kami akan mendapatkan persetujuan anda sebelum mengumpul, menggunakan atau mendedahkan Data Peribadi anda bagi tujuan yang berkaitan."
        },
        {
          "type": "p",
          "text": "Anda boleh memilih untuk tidak memberikan Data Peribadi tertentu. Walau bagaimanapun, sila ambil perhatian bahawa sesetengah maklumat diperlukan untuk kami mendaftarkan anda sebagai pelanggan berdaftar, mengesahkan identiti anda, memproses pendaftaran kad SIM anda, memudahkan pengaktifan pakej dan menyediakan perkhidmatan telekomunikasi yang diminta."
        },
        {
          "type": "p",
          "text": "Jika anda tidak memberikan maklumat yang diperlukan bagi tujuan tersebut, kami mungkin tidak dapat menyelesaikan pendaftaran anda, mendapatkan pengesahan dan kelulusan pelanggan berdaftar yang diperlukan atau menyediakan produk dan perkhidmatan yang berkaitan kepada anda."
        },
        {
          "type": "p",
          "text": "Anda boleh menarik balik persetujuan anda terhadap pemprosesan Data Peribadi dengan mengemukakan permintaan bertulis kepada kami melalui maklumat perhubungan yang dinyatakan dalam Notis Privasi ini. Sebarang penarikan balik persetujuan adalah tertakluk kepada keperluan undang-undang dan obligasi kontrak yang terpakai."
        },
        {
          "type": "p",
          "text": "Sila ambil perhatian bahawa penarikan balik persetujuan mungkin menjejaskan keupayaan kami untuk terus menyediakan produk atau perkhidmatan tertentu kepada anda. Kami juga mungkin terus menyimpan atau memproses Data Peribadi tertentu jika dikehendaki atau dibenarkan oleh undang-undang yang terpakai."
        },
        {
          "type": "h2",
          "text": "Maklumat Wajib dan Sukarela"
        },
        {
          "type": "p",
          "text": "Data Peribadi tertentu adalah wajib bagi tujuan pendaftaran pelanggan berdaftar, pengesahan identiti, pengaktifan kad SIM, pemprosesan pembayaran dan penyediaan perkhidmatan telekomunikasi kami. Anda akan dimaklumkan apabila pemberian maklumat tersebut diwajibkan."
        },
        {
          "type": "p",
          "text": "Maklumat lain boleh diberikan secara sukarela, seperti maklumat perhubungan tambahan atau maklum balas pelanggan, jika berkenaan."
        },
        {
          "type": "p",
          "text": "Jika anda tidak memberikan Data Peribadi yang diperlukan bagi tujuan berkaitan, kami mungkin tidak dapat memproses pendaftaran anda, mengaktifkan kad SIM anda atau menyediakan produk dan perkhidmatan yang diminta."
        }
      ],
      "id": "section-6"
    },
    {
      "title": "Keselamatan Data Peribadi",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat memandang serius perlindungan Data Peribadi anda dan akan mengambil langkah-langkah praktikal yang munasabah untuk melindungi Data Peribadi daripada kehilangan, penyalahgunaan, pengubahsuaian, akses atau pendedahan tanpa kebenaran atau secara tidak sengaja, perubahan atau kemusnahan."
        },
        {
          "type": "p",
          "text": "Langkah-langkah ini mungkin merangkumi perlindungan pentadbiran, organisasi, fizikal dan teknikal yang bersesuaian, seperti:"
        },
        {
          "type": "ul",
          "items": [
            "Mengehadkan akses kepada Data Peribadi kepada kakitangan yang diberi kuasa dan memerlukan akses tersebut bagi tujuan perniagaan yang sah;",
            "Melaksanakan kawalan akses dan langkah pengesahan yang bersesuaian;",
            "Mengekalkan langkah keselamatan yang munasabah bagi aplikasi mudah alih, pangkalan data dan sistem IT kami;",
            "Melindungi maklumat yang dihantar antara sistem kami dengan pembekal perkhidmatan berkaitan melalui langkah keselamatan yang bersesuaian;",
            "Mewajibkan pekerja, wakil dan penyedia perkhidmatan yang berkaitan mematuhi kewajipan kerahsiaan;",
            "Menyemak dan menambah baik amalan perlindungan data dan keselamatan maklumat kami apabila perlu."
          ]
        },
        {
          "type": "p",
          "text": "Apabila Data Peribadi diproses oleh penyedia perkhidmatan pihak ketiga, rakan telekomunikasi atau pihak lain yang diberi kuasa berkaitan dengan penyediaan produk dan perkhidmatan kami, kami akan mengambil langkah yang munasabah untuk memastikan perlindungan dan kewajipan perlindungan data yang sewajarnya dilaksanakan, dengan mengambil kira peranan dan tanggungjawab masing-masing pihak."
        },
        {
          "type": "p",
          "text": "Walaupun langkah-langkah telah diambil, tiada kaedah penghantaran elektronik atau penyimpanan data yang boleh dijamin selamat sepenuhnya. Kami akan terus mengambil langkah yang munasabah untuk melindungi Data Peribadi anda selaras dengan keperluan undang-undang yang terpakai."
        }
      ],
      "id": "section-7"
    },
    {
      "title": "Penyimpanan Data Peribadi",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat akan menyimpan Data Peribadi anda hanya selama tempoh yang diperlukan untuk memenuhi tujuan pengumpulannya, termasuk penyediaan produk dan perkhidmatan kami, pentadbiran akaun pelanggan, pengurusan transaksi, pematuhan kawal selia dan tujuan perniagaan lain yang sah."
        },
        {
          "type": "p",
          "text": "Tempoh penyimpanan mungkin berbeza bergantung pada sifat Data Peribadi, tujuan pemprosesan, tempoh langganan atau hubungan perniagaan anda dengan kami serta sebarang keperluan undang-undang atau kawal selia yang terpakai."
        },
        {
          "type": "p",
          "text": "Selepas tamat tempoh penyimpanan yang berkaitan, atau apabila Data Peribadi tidak lagi diperlukan bagi tujuan pengumpulannya, kami akan mengambil langkah yang munasabah untuk memadam, memusnahkan atau menjadikan maklumat tersebut tanpa nama secara kekal dengan selamat, melainkan penyimpanan selanjutnya dikehendaki atau dibenarkan oleh undang-undang yang terpakai."
        },
        {
          "type": "p",
          "text": "Sila ambil perhatian bahawa rekod pelanggan berdaftar, pendaftaran, transaksi atau telekomunikasi tertentu juga mungkin disimpan oleh pembekal perkhidmatan telekomunikasi berkaitan mengikut keperluan undang-undang, kawal selia dan operasi masing-masing."
        }
      ],
      "id": "section-8"
    },
    {
      "title": "Pemindahan Data Peribadi ke Luar Malaysia",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat mungkin menggunakan penyedia perkhidmatan pihak ketiga atau penyedia teknologi yang menyimpan, mengehos atau memproses Data Peribadi di luar Malaysia."
        },
        {
          "type": "p",
          "text": "Sekiranya Data Peribadi dipindahkan ke luar Malaysia, kami akan memastikan pemindahan tersebut dilaksanakan selaras dengan Seksyen 129 Akta Perlindungan Data Peribadi 2010 dan keperluan pemindahan data rentas sempadan yang terpakai."
        },
        {
          "type": "p",
          "text": "Jika perlu, kami akan mengambil langkah yang munasabah untuk menilai tahap perlindungan yang diberikan kepada Data Peribadi di negara destinasi dan memastikan perlindungan yang sewajarnya atau syarat undang-undang yang terpakai dipenuhi sebelum Data Peribadi dipindahkan."
        },
        {
          "type": "p",
          "text": "Data Peribadi juga mungkin dikongsi dengan pembekal perkhidmatan telekomunikasi berkaitan dan pihak ketiga yang diberi kuasa apabila diperlukan bagi penyediaan produk dan perkhidmatan kami, tertakluk kepada keperluan undang-undang serta perlindungan yang mengawal pemindahan dan pemprosesan Data Peribadi."
        }
      ],
      "id": "section-9"
    },
    {
      "title": "Kuki dan Data Aplikasi Mudah Alih",
      "blocks": [
        {
          "type": "p",
          "text": "Jika berkenaan, laman web dan aplikasi mudah alih kami mungkin menggunakan kuki (cookies), alat pembangunan perisian, log aplikasi dan teknologi seumpamanya untuk mengumpul maklumat teknikal tertentu."
        },
        {
          "type": "p",
          "text": "Maklumat tersebut mungkin termasuk:"
        },
        {
          "type": "ul",
          "items": [
            "Alamat IP;",
            "Jenis peranti dan sistem pengendalian;",
            "Versi aplikasi;",
            "Cap masa log masuk dan akses;",
            "Rekod penggunaan dan interaksi aplikasi;",
            "Maklumat teknikal dan diagnostik."
          ]
        },
        {
          "type": "p",
          "text": "Kami mungkin menggunakan maklumat ini untuk:"
        },
        {
          "type": "ol",
          "items": [
            "Mengekalkan dan meningkatkan prestasi laman web dan aplikasi mudah alih kami;",
            "Mengenal pasti dan menyelesaikan masalah teknikal;",
            "Mengekalkan keselamatan aplikasi dan mencegah akses tanpa kebenaran;",
            "Memahami corak penggunaan umum dan meningkatkan pengalaman pengguna; dan",
            "Menyokong pentadbiran sistem dan pemantauan operasi."
          ]
        },
        {
          "type": "p",
          "text": "Anda boleh mengurus kuki tertentu dan kebenaran aplikasi melalui tetapan pelayar atau peranti anda. Walau bagaimanapun, menyahaktifkan teknologi atau kebenaran tertentu mungkin menjejaskan ketersediaan atau fungsi sesetengah perkhidmatan."
        },
        {
          "type": "p",
          "text": "Jika analitik pihak ketiga atau teknologi seumpamanya digunakan, pengumpulan dan pemprosesan maklumat oleh pihak ketiga tersebut mungkin juga tertakluk kepada dasar privasi pihak ketiga yang berkenaan."
        }
      ],
      "id": "section-10"
    },
    {
      "title": "Pemasaran Langsung",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat mungkin menggunakan maklumat perhubungan anda untuk memberikan kemas kini, bahan promosi, tawaran dan maklumat berkaitan produk dan perkhidmatan kami, setakat yang dibenarkan oleh undang-undang yang terpakai."
        },
        {
          "type": "p",
          "text": "Komunikasi sedemikian mungkin disampaikan melalui SMS, panggilan telefon, e-mel, aplikasi pemesejan, pemberitahuan aplikasi mudah alih atau saluran komunikasi lain."
        },
        {
          "type": "p",
          "text": "Kami menghormati pilihan anda berhubung komunikasi pemasaran. Jika anda tidak lagi mahu menerima mesej promosi atau pemasaran daripada kami, anda boleh memohon untuk menarik diri dengan menghubungi kami melalui maklumat perhubungan yang dinyatakan dalam Notis Privasi ini atau menggunakan kemudahan berhenti melanggan atau menarik diri yang disediakan dalam komunikasi berkenaan."
        },
        {
          "type": "p",
          "text": "Sila ambil perhatian bahawa tindakan menarik diri daripada komunikasi pemasaran tidak akan menghalang kami daripada menghantar pemberitahuan penting berkaitan perkhidmatan, termasuk kemas kini pendaftaran, pengesahan pembayaran, pemberitahuan keselamatan dan pengumuman perkhidmatan yang penting."
        }
      ],
      "id": "section-11"
    },
    {
      "title": "Hak Anda di bawah PDPA",
      "blocks": [
        {
          "type": "p",
          "text": "Tertakluk kepada Akta Perlindungan Data Peribadi 2010 dan undang-undang lain yang terpakai, anda boleh melaksanakan hak-hak berikut berhubung Data Peribadi anda:"
        },
        {
          "type": "h",
          "text": "A. Hak untuk Mengakses"
        },
        {
          "type": "p",
          "text": "Anda boleh memohon akses kepada Data Peribadi anda yang disimpan oleh Jejak Semangat, tertakluk kepada keperluan undang-undang dan prosedur pengesahan yang terpakai."
        },
        {
          "type": "h",
          "text": "B. Hak untuk Membetulkan"
        },
        {
          "type": "p",
          "text": "Anda boleh memohon pembetulan atau pengemaskinian Data Peribadi yang tidak tepat, tidak lengkap, mengelirukan atau lapuk."
        },
        {
          "type": "h",
          "text": "C. Hak untuk Menarik Balik Persetujuan"
        },
        {
          "type": "p",
          "text": "Jika pemprosesan adalah berdasarkan persetujuan anda, anda boleh menarik balik persetujuan tersebut dengan memberikan notis bertulis kepada kami, tertakluk kepada keperluan undang-undang yang terpakai dan sebarang akibat yang timbul daripada penarikan balik tersebut."
        },
        {
          "type": "h",
          "text": "D. Hak untuk Menghalang Pemprosesan bagi Tujuan Pemasaran Langsung"
        },
        {
          "type": "p",
          "text": "Anda boleh meminta kami menghentikan pemprosesan Data Peribadi anda bagi tujuan pemasaran langsung."
        },
        {
          "type": "h",
          "text": "E. Hak untuk Menghalang Pemprosesan yang Berkemungkinan Menyebabkan Kerosakan atau Tekanan"
        },
        {
          "type": "p",
          "text": "Anda boleh menggunakan hak yang terpakai untuk menghendaki kami menghentikan atau tidak memulakan pemprosesan Data Peribadi sekiranya pemprosesan tersebut berkemungkinan menyebabkan kerosakan atau tekanan yang ketara, selaras dengan PDPA."
        },
        {
          "type": "h",
          "text": "F. Hak Kemudahalihan Data"
        },
        {
          "type": "p",
          "text": "Jika berkenaan, anda boleh memohon supaya Data Peribadi anda dihantar secara langsung kepada pengawal data lain yang anda pilih, tertakluk kepada kebolehlaksanaan teknikal, keserasian format data yang berkaitan dan keperluan undang-undang lain yang terpakai."
        },
        {
          "type": "p",
          "text": "Untuk melaksanakan mana-mana hak ini, sila kemukakan permintaan bertulis melalui maklumat perhubungan yang dinyatakan dalam Notis Privasi ini."
        },
        {
          "type": "p",
          "text": "Kami mungkin meminta maklumat tambahan untuk mengesahkan identiti anda sebelum memproses permintaan tersebut. Kami akan memberikan maklum balas terhadap permintaan anda selaras dengan undang-undang dan peraturan yang terpakai."
        },
        {
          "type": "p",
          "text": "Sila ambil perhatian bahawa permintaan tertentu mungkin tertakluk kepada pengecualian atau had undang-undang, atau keadaan yang membolehkan kami menolak permintaan tersebut di bawah undang-undang yang terpakai."
        }
      ],
      "id": "section-12"
    },
    {
      "title": "Perhubungan Privasi dan Perlindungan Data",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat komited untuk mengekalkan akauntabiliti dan pengawasan yang sewajarnya terhadap aktiviti pemprosesan Data Peribadinya."
        },
        {
          "type": "p",
          "text": "Untuk pertanyaan, permintaan atau aduan berkaitan pengumpulan, pemprosesan atau perlindungan Data Peribadi anda, anda boleh menghubungi kami melalui saluran berikut:"
        },
        {
          "type": "h2",
          "text": "Pertanyaan Privasi / Perhubungan Perlindungan Data"
        },
        {
          "type": "p",
          "text": "E-mel: compliance@mobilityone.com.my"
        },
        {
          "type": "p",
          "text": "Telefon: +603 9213 0688"
        },
        {
          "type": "p",
          "text": "Alamat: Wisma LMS, No. 6, Jalan Abdul Rahman Idris, Kg Baru, 50300 Kuala Lumpur, Malaysia."
        },
        {
          "type": "p",
          "text": "Jika dikehendaki di bawah undang-undang dan garis panduan kawal selia yang terpakai, Jejak Semangat akan melantik dan mendaftarkan Pegawai Perlindungan Data (DPO) untuk menyelia perkara berkaitan perlindungan data peribadi."
        }
      ],
      "id": "section-13"
    },
    {
      "title": "Hubungi Kami",
      "blocks": [
        {
          "type": "p",
          "text": "Jika anda mempunyai sebarang pertanyaan, kebimbangan, permintaan atau aduan berhubung Notis Privasi ini atau pengendalian Data Peribadi anda oleh Jejak Semangat, sila hubungi kami melalui saluran berikut:"
        },
        {
          "type": "h",
          "text": "JEJAK SEMANGAT SDN BHD"
        },
        {
          "type": "p",
          "text": "Alamat Berdaftar: Wisma LMS, No. 6, Jalan Abdul Rahman Idris, Kg Baru, 50300 Kuala Lumpur, Malaysia"
        },
        {
          "type": "p",
          "text": "E-mel: enquiry@tfp.com.my"
        },
        {
          "type": "p",
          "text": "Laman web: https://www.tfp.com.my/"
        },
        {
          "type": "p",
          "text": "Perhubungan: https://linktr.ee/tfpsolutionsofficial"
        },
        {
          "type": "p",
          "text": "Kami akan berusaha secara munasabah untuk menangani pertanyaan dan kebimbangan anda dalam tempoh yang sewajarnya serta selaras dengan undang-undang dan peraturan yang terpakai."
        }
      ],
      "id": "section-14"
    },
    {
      "title": "Perubahan kepada Notis Privasi Ini",
      "blocks": [
        {
          "type": "p",
          "text": "Jejak Semangat berhak untuk meminda, mengemas kini atau menyemak Notis Privasi ini dari semasa ke semasa bagi mencerminkan perubahan dalam operasi perniagaan, produk dan perkhidmatan kami, perkembangan teknologi, keperluan undang-undang atau obligasi kawal selia."
        },
        {
          "type": "p",
          "text": "Sebarang versi Notis Privasi yang dikemas kini akan diterbitkan melalui laman web rasmi, aplikasi mudah alih atau saluran komunikasi lain yang bersesuaian."
        },
        {
          "type": "p",
          "text": "Jika dikehendaki, kami akan memaklumkan anda tentang perubahan penting kepada Notis Privasi ini."
        },
        {
          "type": "p",
          "text": "Kami menggalakkan anda menyemak Notis Privasi ini dari semasa ke semasa supaya anda sentiasa mengetahui cara kami mengumpul, menggunakan, memproses dan melindungi Data Peribadi anda."
        },
        {
          "type": "p",
          "text": "Versi terkini Notis Privasi ini akan menggantikan semua versi terdahulu."
        }
      ],
      "id": "section-15"
    }
  ],
  "lastUpdated": "Tarikh Kemas Kini Terakhir: 2 November 2026"
};

export default privacyNoticeMs;
